var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompassDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 279.997 280 L 163.331 536.667 L 419.997 420 L 536.664 163.333 L 279.997 280 Z M 257.308 442.681 L 315.235 315.233 L 384.756 384.754 L 257.308 442.681 Z",
    style: {
      fill: "rgb(161, 160, 159)"
    },
    transform: "matrix(0.707107, -0.707107, 0.707107, 0.707107, -144.975471, 349.99806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653.331 350 C 653.331 517.264 517.257 653.333 349.997 653.333 C 182.733 653.333 46.664 517.26 46.664 350 C 46.664 182.736 182.737 46.667 349.997 46.667 C 517.261 46.667 653.331 182.735 653.331 350 M 700 350 C 700 156.694 543.306 0 350 0 C 156.694 0 0 156.694 0 350 C 0 543.306 156.694 700 350 700 C 543.306 700 700 543.306 700 350 Z",
    style: {
      fill: "rgb(161, 160, 159)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassDark);
export default __webpack_public_path__ + "static/media/compass-dark.c90c349d1e59c15c6298a8bf2ba844d7.svg";
export { ForwardRef as ReactComponent };